import React from 'react';
import styled from "styled-components";
import CurrencyFormatter from "../../../Components/Commons/CurrencyFormatter.react";
import {useHistory} from "react-router";

const size = {
  mobileS: '320px',
  mobileM: '375px',
  mobileL: '652px',
  tablet: '1021px',
  laptop: '1022px',
  laptopL: '1440px',
  desktop: '2560px'
}

export const device = {
  mobileS: `(min-width: ${size.mobileS})`,
  mobileM: `(min-width: ${size.mobileM})`,
  mobileL: `(max-width: ${size.mobileL})`,
  tablet: `(max-width: ${size.tablet})`,
  laptop: `(min-width: ${size.laptop})`,
  laptopL: `(min-width: ${size.laptopL})`,
  desktop: `(min-width: ${size.desktop})`,
  desktopL: `(min-width: ${size.desktop})`
};

export const StyledTable = styled.table`
  width: 100%;
  border: 2px solid #E2E5E8;
  
  @media ${device.tablet} { 
    .tc-row {
      display: flex;
      flex-direction: column;
      justify-content: center;
      
      #tc-name, #tc-email, #tc-date, #tc-id {
        padding-left: 8rem;
        font-size: 2.2rem;
      }
      
      .customer-label {
        width: 8rem;
        position: absolute;
        transform: translate(-60px, -1px);
      }
    }
  }
  
  @media ${device.tablet} { 
    .tc-row {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-left: auto;
      
      #tc-name, #tc-email, #tc-date, #tc-id {
        padding-left: 8rem;
        font-size: 2.2rem;
      }
      
      .customer-label {
        width: 8rem;
        position: absolute;
        transform: translate(-60px, -1px);
      }
    }
  }
    
  @media ${device.laptop} {
    .tc-row {
      .customer-label {
        display: none;
      }
    }
    
    #tc-name {
      width: 16rem;
    }
    
    #tc-email {
      width: 35rem;
    }
    
    #tc-date {
      width: 10rem;
    }
    
    #tc-id {
      width: 32rem;
    }
    
    .table-header {
      .th-Name {
        width: 16rem;
      }
  
      .th-Email {
        width: 35rem;
      }
      
      .th-Created {
        width: 10rem;
      }
      
      .th-ID {
        width: 32rem;
      }
    }
  }
  
  @media ${device.laptopL} { 
    #tc-name {
      width: 32rem;
    }
    
    #tc-email {
      width: 50rem;
    }
    
    #tc-date {
      width: 14rem;
    }
    
    #tc-id {
      width: 40rem;
    }
    
    .table-header {
      .th-Name {
        width: 32rem;
      }
      
      .th-Email {
        width: 50rem;
       }
      
      .th-Created {
        width: 14rem;
      }
      
      .th-ID {
        width: 40rem;
        padding-left: 2rem;
      }
    }
  }
`

export const TableHeader = styled.tr`
  color: black;
  background-color: #FFFFFF;
  border-bottom: 2px solid #E2E5E8;
  display: flex;
  justify-content: space-evenly;

  th {
    font-size: 2rem;
    width: 100%;
    text-align: center;
  }
  
  th.small {
   width: 50%;
  }
`

export const TableRow = styled.tr`
  color: black;
  background-color: ${(props) => props.index % 2 === 0 ? '#FAFAFA' :'#F3F6F9'};
  ${(props) => props.cursor && `cursor: ${props.cursor}`};
  display: flex;
  justify-content: space-evenly;
  align-items: stretch;
  :hover {
    cursor: pointer;
    background-color: ${(props) => props.index % 2 === 0 ? '#ededed' :'#e2e9f1'};
    color: #0288BD;
    
  }
`

export const TableCell = styled.td`
  width: ${(props) => props.width ? `${props.width}` :'100%'};
  font-size: 2rem;
  padding: 3rem 4rem;
  flex-grow : 1;
  text-align: ${(props) => props.textAlign ? props.textAlign : 'left'};
  font-family: ${(props) => props.fontFamily ? props.fontFamily : 'inherit'};
`


const StyledJournalEntry = styled.div`
  background-color: white;
  color: #575757;
  
  .header {
    line-height: 110%;
    padding: 2.5rem 3rem;
    letter-spacing: 1px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title {
      font-size: 2.5rem;
    }
    
    .export-btn {
      border: 1px solid black;
      padding: 1rem 2rem;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  
  .table {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  
  .column {
    border: 1px solid black;
    width: 100%;
    text-align: right;
    
    .table-body {
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      .cell {
        height: 6rem;
      }
    }
  }
  .column:first-child {
    text-align: left;
  }
`

const JournalEntry = ({transaction}) => {
  const history = useHistory();

  const handleOnClick = () => {
    history.push(`/accounting/id=${transaction.id}`)
  }

  return (
    <StyledJournalEntry>
      <div className={'header'}>
        <div className={'title'}>Journal Entry</div>
        {/*<div className={'export-btn'}>Export Journal<Icon>file_download</Icon></div>*/}
      </div>
      <StyledTable>
        <TableHeader>
          <th>Account</th>
          <th>USD Debit</th>
          <th>USD Credit</th>
          <th>BTC Debit</th>
          <th>BTC Credit</th>
        </TableHeader>
        {
          transaction && transaction.lines?.map((line, index) => {
            const {account, journalAssetQuantity, inventoryAssetQuantity, lineType} = line;
            return (
              <TableRow onClick={handleOnClick} key={index} index={index}>
                <TableCell fontFamily="monospace" textAlign="right" borderRight="2px solid #E2E5E8">
                  {account}
                </TableCell>
                <TableCell fontFamily="monospace" textAlign="right" borderRight="2px solid #E2E5E8">
                  {lineType == 'credit' &&
                    <CurrencyFormatter type={'FIAT'} quantity={journalAssetQuantity.quantity} code={'USD'} symbol={'$'} />
                  }
                </TableCell>
                <TableCell fontFamily="monospace" textAlign="right" borderRight="2px solid #E2E5E8">
                  {lineType == 'debit' &&
                  <CurrencyFormatter type={'FIAT'} quantity={journalAssetQuantity.quantity} code={'USD'} symbol={'$'} />
                  }
                </TableCell>
                <TableCell fontFamily="monospace" textAlign="right" borderRight="2px solid #E2E5E8">
                  {lineType == 'credit' &&
                  <CurrencyFormatter type={'ASSET'} quantity={inventoryAssetQuantity?.quantity} code={inventoryAssetQuantity?.asset} />
                  }
                </TableCell>
                <TableCell fontFamily="monospace" textAlign="right" borderRight="2px solid #E2E5E8">
                  {lineType == 'debit' &&
                  <CurrencyFormatter type={'ASSET'} quantity={inventoryAssetQuantity?.quantity} code={inventoryAssetQuantity?.asset} />
                  }
                </TableCell>
              </TableRow>
            )
          })
        }
      </StyledTable>
    </StyledJournalEntry>
  )
}

export default JournalEntry;